<template>
  <div class="min-vh-100 d-flex flex-column">
    <component v-if="header_type" :is="`${header_type}-header`" />
    <main class="container-fluid px-md-5 flex-grow-1 d-flex flex-column">
      <router-view
        class="flex-grow-1"
        @openAudioPlauer="$emit('openAudioPlauer')"
        @tvconnect="tvconnect"
        @tvlist="requestAvailableTvs"
      />
    </main>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { configurations } from "@/store/modules/hotel/configuration";

import ClassicalHeader from "../app/headers/classical-header.vue";
import EmptyHeader from "../app/headers/empty-header.vue";

import type { IComandData } from "@/@types/connection/tvs";

@Options({
  name: "main-layout",
  components: { ClassicalHeader, EmptyHeader },
})
class MainLayout extends Vue {
  get header_type(): string {
    const customer = configurations().getCustomer;
    switch (customer) {
      case "ksk":
        return "empty";
      case "don":
        return "classical";
      default:
        return "classical";
    }
  }

  tvconnect(command_name: string, command_data: IComandData | null): void {
    this.$emit("tvconnect", command_name, command_data);
  }

  requestAvailableTvs(): void {
    this.$emit("tvlist");
  }
}
export default MainLayout;
</script>
<style lang="scss"></style>
